import { createFileRoute } from "@tanstack/react-router";
import { ChatPage } from "@/pages/team/Chat";

/**
 * Der Team-Chat (CHAT-AUFTRAG.md). `?kanal=` wählt den Raum, `?nachricht=`
 * springt zu einer Nachricht — so verlinkt die Glocke eine Erwähnung.
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/chat")({
	validateSearch: (suche: Record<string, unknown>): { kanal?: string; nachricht?: string } => ({
		kanal: typeof suche.kanal === "string" ? suche.kanal : undefined,
		nachricht: typeof suche.nachricht === "string" ? suche.nachricht : undefined,
	}),
	component: ChatPage,
});
